import React, { useState } from 'react'
import Modal from 'react-modal'

const defaultProps = {
  gateAddresses: [],
}

const GateAddresses = ({ areGateAddressesEditable, gateAddresses, lockId, onAddGateAddresses, onToggleGateAddresses }) => {
  const [addresses, setAddresses] = useState(gateAddresses.map((a) => a.street).join('; '))

  return (
    <div style={{ marginTop: 10 }}>
      <button onClick={onToggleGateAddresses}>Grindadresser</button>
      <Modal onRequestClose={onToggleGateAddresses} isOpen={areGateAddressesEditable}>
        <button style={{ float: 'right', borderRadius: 3 }} onClick={onToggleGateAddresses}>
          X
        </button>
        <div
          style={{
            padding: 7,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <h3>Grindadresser</h3>
          <textarea onChange={(e) => setAddresses(e.target.value)} style={{ width: '50%', height: 200 }} placeholder="Björkvägen 1; Bjökvägn 1; Bjokvgn 1" defaultValue={addresses} />
          <div style={{ marginTop: 10 }}>
            <button onClick={() => onAddGateAddresses(addresses, lockId)}>Spara</button>
          </div>
        </div>
      </Modal>
    </div>
  )
}

GateAddresses.defaultProps = defaultProps

export default GateAddresses
